import * as angular from 'angular';
import * as _ from 'lodash';
import PermissionResource from '../models/permission-resource';
import ResourceService from './resource.service';

export default class PermissionService extends ResourceService<PermissionResource> {
  constructor(BaseResource) {
    super(BaseResource, PermissionResource);
  }
}

angular
  .module('ciApp.services')
  .service('PermissionService', ['BackendService', PermissionService]);



// WEBPACK FOOTER //
// ./common/services/permission.service.ts